module.exports = __webpack_public_path__ + "img/product1.jpg?97952b13a4a75a1004e025d2fe571269";